import { render } from "./Low52Signals.vue?vue&type=template&id=56df7a92&scoped=true"
import script from "./Low52Signals.vue?vue&type=script&lang=js"
export * from "./Low52Signals.vue?vue&type=script&lang=js"

import "./Low52Signals.vue?vue&type=style&index=0&id=56df7a92&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56df7a92"]])

export default __exports__